import CopperView from '../components/common/materials/Copper';
import { COPPER, COPPER_FILL } from '../constants/globals'
import Material from './Material';
import { copperOz2inch, inchToString } from '../lib/unitConversions';
import { calcFillRatio, isOuterCopper } from '../lib/copper';

const sanitize = (copper) => {
  const {
    signal,
    transmissionWidth,
    transmissionSpacing,
    weight,
    copperFill,
    plating,
    warnings
  } = copper;

  return {
    signal,
    transmissionWidth,
    transmissionSpacing,
    weight,
    copperFill,
    plating,
    warnings
  };
}

export class Copper extends Material {
  constructor(copper) {
    super(sanitize(copper));

    // These properties intended not to be changed once set
    this.type                = COPPER;
    this.view                = CopperView.displayName;
  }

  isOuterCopper() {
    return isOuterCopper(this, this.getLayers());
  }

  update(copper) {
    return Object.assign(this, {
      name: copper.name, 
      _material: {...this._material, ...sanitize(copper)}
    });
  }

  get displayName() {
    return this.name || `L${this.typeIndex}`;
  }

  get weight() {
    return this.material ? this.material.weight : 1;
  }

  get copperFill() {
    return this.material && this.material.copperFill ?
      this.material.copperFill : 
      COPPER_FILL;
  }

  get copperFillPercent() {
    return this.copperFill * 100;
  }

  get signal() {
    return this.material ? this.material.signal : false;
  }

  get transmissionWidth() {
    return this.material ? this.material.transmissionWidth : 0;
  }

  get transmissionSpacing() {
    return this.material ? this.material.transmissionSpacing : 0;
  }

  get construction() {
    return `Copper ${this.weight}oz ${this.copperFill}% Fill`;
  }

  get plating() {
    // Copper plating is only for outer coppers
    return this.material && this.material.plating && this.isOuterCopper()
      ? this.material.plating
      : 0;
  }

  get thickness() {
    const { weight } = this;
    const plating = this.plating;
    const isOuter = this.isOuterCopper();
    const thickness = copperOz2inch(weight, plating, isOuter);
    return thickness;
  } 

  get spaceNeeded() {
    return this.thickness_px;
  }

  get viewProps() {
    return {
      copperFill: this.copperFill
    }
  }

  fillRatio() {
    return calcFillRatio(this.thickness, this.copperFill);
  }

  summary(unit) {
    return `${this.displayName} - ${inchToString(this.thickness, unit)}`;
  }

  toString() {
    return this.displayName;
  }
}

export const defaultInnerCopper = weight =>
  new Copper({ weight, copperFill: COPPER_FILL });

export const defaultOutterCopper = weight =>
  new Copper({ weight, copperFill: 1 });

export default Copper;


// WEBPACK FOOTER //
// ./src/models/Copper.js